import { useEffect } from "react";
import ReactGA from "react-ga4";

export const useLinkTracking = () => {
  const handleClick = (e: MouseEvent) => {
    if (e.target instanceof HTMLAnchorElement || (e.target instanceof HTMLElement && e.target.parentElement instanceof HTMLAnchorElement)) {
      const target = e.target instanceof HTMLAnchorElement ? e.target : (e.target.parentElement as HTMLAnchorElement);

      const event = {
        category: target.getAttribute("data-gatrack-category") || "Component",
        action: target.getAttribute("data-gatrack-action") || "Clicked",
        label: target.getAttribute("data-gatrack-label") || target.textContent || target.href,
      };

      ReactGA.event(event);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  });
};
